export class BreedModel {
    breed_index: number
    breed_name: string

    constructor(
        breed_index: number,
        breed_name: string
    ) {
        this.breed_index = breed_index
        this.breed_name = breed_name
    }
}